import React from 'react';
import PropTypes from 'prop-types';
import { getIn } from 'formik';
import { IonInput, IonItem, IonLabel, IonText } from '@ionic/react';
import { toPattern } from 'utils/masker';

function InputField({
  field,
  form,
  disabled,
  label,
  onChange,
  note,
  mask,
  warningText,
  strongLabel = false,
  ...rest
}) {
  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);
  const hasError = !!(touched && error);
  
  const handleChange = (e) => {
    if (mask) {
      form.setFieldValue(field.name, toPattern(e.target.value, mask));
    } else {
      field.onChange(e);
    }
  };

  return (
    <IonItem lines="full">
      <IonLabel color="dark" position="stacked">
        {strongLabel ? <strong>{label}</strong> : label}
      </IonLabel>

      <IonInput
        disabled={form.isSubmitting || disabled}
        {...rest}
        {...field}
        color={hasError ? 'danger' : 'primary'}
        onIonChange={handleChange}
      />

      {note}
      {hasError && (
        <IonText color="danger">
          <small>{error}</small>
        </IonText>
      )}
      {warningText && (
        <IonText color="danger">
          <small>{warningText}</small>
        </IonText>
      )}
    </IonItem>
  );
}
InputField.propTypes = {
  label: PropTypes.string,
  field: PropTypes.object,
  note: PropTypes.node,
  mask: PropTypes.string,
  form: PropTypes.object,
  warningText: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  strongLabel: PropTypes.bool,
};
export default InputField;
